import(/* webpackMode: "eager" */ "/app/app/[lang]/(common-header-footer)/(home)/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/analytics/page-load-complete/page-load-complete.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/back-to-top-section/back-to-top-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/faq-section/accordion/accordion-description/accordion-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/faq-section/accordion/accordion-head-wrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/faq-section/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/faq-section/accordion/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/faq-section/visiblity-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-cards/horizontal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/game-cards/square/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/game-cards/vertical/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/game-cards/vertical/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/game-cards/square/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/header/analytics/visiblity-analytics-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/all-tags/tag-icon-and-name/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/analytics/analytics-wrapper-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/featured-games/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/games-by-tag/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/gamezop-originals/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/especially-for-you/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/tag-section-head/view-all-btn/view-all-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/load-on-interaction/interaction-placeholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadOnUserInteractionClient"] */ "/app/app/components/load-on-interaction/load-on-interaction-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/all-tags-slider/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/all-tags/tag-icon-and-name/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/home-page-sections/all-tags/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/continue-playing-slider/continue-playing-slider-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/games-by-tag-slider/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/gamezop-originals-slider/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/expecially-for-you-slider/style.module.css");
;
import(/* webpackMode: "eager" */ "/app/app/components/back-to-top-section/style.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/components/sliders/slider/analytics-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/sliders/slider/slider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-collapser/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/ad-not-found/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/rsc/ads/display-ad/display-ad.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentScript"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/script/consent-script.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
